import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function exactNumberOfCharactersValidator(num: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if ((control?.value || '').length === 0 || !num) {
      return null;
    }

    const isValid = control.value.length === num;

    return isValid ? null : { exactNumCharactersInvalid: num };
  };
}
